/**
 * Application-wide constants
 */

// Token expiration durations (in hours)
export const TOKEN_EXPIRATION = {
  DEFAULT_HOURS: 72,
  ONE_DAY: 24,
  THREE_DAYS: 72,
  ONE_WEEK: 168,
} as const;

// Phone number validation
export const PHONE_NUMBER = {
  US_DIGIT_LENGTH: 10,
} as const;

// Time formats
export const TIME_FORMAT = {
  MILITARY_EXAMPLE: '14:30',
  CIVILIAN_EXAMPLE: '2:30 PM',
} as const;
